var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-toggle",class:{ open: _vm.isOpen },on:{"click":function($event){return _vm.menuToggle()}}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }